import { render } from "./AddQwilrDataSource.vue?vue&type=template&id=6416a8a4&scoped=true"
import script from "./AddQwilrDataSource.vue?vue&type=script&lang=js"
export * from "./AddQwilrDataSource.vue?vue&type=script&lang=js"

import "./AddQwilrDataSource.vue?vue&type=style&index=0&id=6416a8a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6416a8a4"]])

export default __exports__